import { Skeleton, Text, VStack } from '@hivewatch/dark'

interface SOPInfoBoxIProps {
  title: string
  isLoading?: boolean
  children?: React.ReactNode
}

export const SOPStatusBox = ({
  title,
  isLoading,
  children,
}: SOPInfoBoxIProps) => {
  return (
    <VStack height='100%' justifyContent='center'>
      {isLoading ? (
        <Skeleton h='27px' loading w='108px' />
      ) : (
        <Text fontSize='18px' fontWeight='semibold' letterSpacing='-0.53px'>
          {title}
        </Text>
      )}
      {children}
    </VStack>
  )
}
